import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface Briefing {
  id: string;
  at: number;
  text: string;
}

interface State {
  briefings: Briefing[];
  add: (text: string) => void;
  remove: (id: string) => void;
}

const uid = () => "b" + Math.random().toString(36).slice(2, 10);

export const useBriefings = create<State>()(
  persist(
    (set) => ({
      briefings: [],
      add: (text) => set(s => ({
        briefings: [{ id: uid(), at: Date.now(), text }, ...s.briefings].slice(0, 60)
      })),
      remove: (id) => set(s => ({
        briefings: s.briefings.filter(b => b.id !== id)
      }))
    }),
    { name: "agencia-vpc-briefings-v1" }
  )
);
